import React, { Fragment, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import estilos from '../../UsuarioInspectorEnCampo/Asociados/PanelAsociadoComponent.module.css'
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { ObtenerClientes } from '../../../redux/DucksAtencionACliente/ModuloConsultaDucks';
import FormularioFisicoQuimico from './FormularioFisicoQuimico';
import { iniciarSesion, obtenerLotesRebeca } from '../../../redux/DucksUnidadInspeccion/RebeckaDuck';
import { subirArchivosLotes } from '../../../redux/DucksUnidadInspeccion/ArchivosDuck';
import { obtenerDocumentosByLote, eliminarDocumento, obtenerDocumentosByAnalisis } from '../../../redux/DucksUnidadInspeccion/DocumentosLoteDuck';
import { obtenerAnalisisByLote } from '../../../redux/DucksUnidadInspeccion/AnalisisFQDuck';
import { hostSocket } from '../../../configuraciones';
import { DeleteOutlined, RemoveRedEyeOutlined, FindInPage, Visibility } from '@mui/icons-material';
import VerAnalisisFQComponent from './VerAnalisisFQComponent';
import { Store } from 'react-notifications-component';

function TableBusquedaLotesComponent(props) {

    const dispatch = useDispatch()

    const clientes = useSelector(store => store.ModuloConsulta.clientes);

    const [cajaBusqueda, setcajaBusqueda] = React.useState('');
    const [clientesFiltrados, setClientesFiltrados] = React.useState([]);
    const [clienteSeleccionado, setClienteSeleccionado] = React.useState(1);
    const [opcionesOcultas, setOpcionesOcultas] = React.useState(true);

    const [openFormularioFisicoQuimico, setOpenFormularioFisicoQuimico] = React.useState(false);

    const [openPDF, setOpenPDF] = React.useState(false);

    const [openFQ, setOpenFQ] = React.useState(false);

    const [lotesRebeca, setLotesRebeca] = React.useState([]);

    const [todosLotes, setTodosLotes] = React.useState([])

    const [lotesFiltrados, setLotesFiltrados] = React.useState([]);

    const [loteSeleccionado, setLoteSeleccionado] = React.useState(null);

    const [selectedFile, setSelectedFile] = React.useState(null);

    const [documentosLote, setDocumentosLote] = React.useState([]);

    const [documentosAnalisis, setDocumentosAnalisis] = React.useState([]);

    const [analisis, setAnalisis] = React.useState([]);

    const [analsisSeleccionado, setAnalisisSeleccionado] = React.useState(null);

    const [verAnalisis, setVerAnalisis] = React.useState(null);

    const [resultado, setResultado] = React.useState(false)

    const handleAbrirModalFormularioFisicoQuimico = (a) => {
        //setAnalisisSeleccionado(null)
        setOpenFormularioFisicoQuimico(true);
    }

    const handleCerrarModalFormularioFisicoQuimico = () => {
        setOpenFormularioFisicoQuimico(false);
    }

    const handleAbrirModalPDF = (a) => {
        const data = {
            analisis: a.analisisfq
        }
        dispatch(obtenerDocumentosByAnalisis(data)).then((res) => {
            setDocumentosAnalisis(res.payload.data.data)
        })
        setAnalisisSeleccionado(a)
        setOpenPDF(true);
    }

    const handleCerrarModalPDF = () => {
        setAnalisisSeleccionado(null)
        setOpenPDF(false);
    }

    const handleAbrirModalFQ = (l) => {
        const data = {
            lote: l
        }

        dispatch(obtenerAnalisisByLote(data)).then((res) => {
            setAnalisis(res.payload.data.data)
        })
        setLoteSeleccionado(l)
        setOpenFQ(true);
    }

    const handleCerrarModalFQ = () => {
        setLoteSeleccionado(null)
        setOpenFQ(false);
    }

    const handleAbrirModalVerFisicoQuimico = (a) => {
        setAnalisisSeleccionado(a)
        setVerAnalisis(true);
    }

    const handleCerrarModalVerFisicoQuimico = () => {
        setVerAnalisis(false);
    }

    const handleChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);
    };

    const actualizarAnalisis = () => {
        const data = {
            lote: loteSeleccionado
        }

        dispatch(obtenerAnalisisByLote(data)).then((res) => {
            setAnalisis(res.payload.data.data)
        })
    }

    React.useEffect(() => {
        dispatch(ObtenerClientes())   //clientes //clientes     
        dispatch(iniciarSesion()).then((res) => {
            dispatch(obtenerLotesRebeca()).then((res) => {
                console.log(res.payload)
                setLotesRebeca(res.payload)
            })
        })
    }, []);

    React.useEffect(() => {
        analisis
    }, [analisis]);

    React.useEffect(() => {

        let todos = []

        lotesRebeca.forEach((l) => {
            l.lotes.forEach((t) => {
                todos.push(t)
            })
        })
        setTodosLotes(todos)
    }, [lotesRebeca]);

    React.useEffect(() => {
        var expresionRegular = /[\[\]\(\)\{\};,.<>=!&|+\-*\/%~^?:"'\\]/;
        if (cajaBusqueda != '') {
            setOpcionesOcultas(false);
            //DOS CASOS
            if (expresionRegular.test(cajaBusqueda)) {
                let lfiltro = []
                lotesRebeca.map((l) => {
                    l.lotes.map((ls) => {
                        if (ls.lote.toUpperCase().includes(cajaBusqueda.toUpperCase())) {
                            let data = {
                                noCliente: l.noCliente,
                                lote: ls
                            }
                            lfiltro.push(data)
                        }
                    })
                })
                setLotesFiltrados(lfiltro)
                //setLotesFiltrados(lotesRebeca?.filter(l => l.lotes?.lote?.toUpperCase().includes(cajaBusqueda.toUpperCase())))
                setOpcionesOcultas(true);
                setResultado(false)
            }
            //|1| SI ES POR NÚMERO DE SOCIO
            else if (!isNaN(cajaBusqueda)) {
                setLotesFiltrados([])
                setClientesFiltrados(clientes?.filter(c => c.numerosocio.toUpperCase().includes(cajaBusqueda.toUpperCase())));
                setResultado(true)
            }
            else {
                //|2| SI ES POR RAZÓN SOCIAL
                setLotesFiltrados([])
                setClientesFiltrados(clientes?.filter(c => c.nombrerazonsocial.toUpperCase().includes(cajaBusqueda.toUpperCase())));
                setResultado(true)
            }
            if (clientesFiltrados.length > 0) {
                setClienteSeleccionado(clientesFiltrados[0]);
            }
        } else if (cajaBusqueda.length === 0) {
            setOpcionesOcultas(true);
        }
        else {
            instalaciones = []
        }

    }, [cajaBusqueda])

    const handleBuscarInstalaciones = (event) => {
        setcajaBusqueda(event.target.value);
    }

    const handleElegirCliente = (cliente) => {
        if (cajaBusqueda != '') {
            setcajaBusqueda(cliente.nombrerazonsocial);
            setClienteSeleccionado(cliente);
            //dispatch(getInstalacionesByCliente(cliente.idcliente));
        } else {
            alert('Ingrese un número de cliente o razón social');
        }
    }

    React.useEffect(() => {
        let filtro = []
        let aux = lotesRebeca.filter((lote) => lote.noCliente == clienteSeleccionado.numerosocio)

        if (aux.length > 0) {
            filtro = aux[0].lotes
        }

        setLotesFiltrados(filtro)
    }, [clienteSeleccionado])

    const style = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 1500, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
        p: 4, fontSize: '20px', textAlign: 'center', overflow: 'scroll', height: '85%'
    };
    const styleVisualizar = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 1000, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
        p: 4, fontSize: '20px', textAlign: 'center', overflow: 'scroll', height: '85%'
    };
    const styleModalPequeño = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 1000, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
        p: 4, fontSize: '20px', textAlign: 'center', overflow: 'scroll', height: '85%'
    };
    const styleModalNormal = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 1500, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
        p: 4, fontSize: '20px', textAlign: 'center', overflow: 'scroll', height: '85%'
    };

    const stylePDF = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 700, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
        p: 4, fontSize: '20px', textAlign: 'center', overflow: 'scroll', height: '60%'
    };

    const styleBox = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };


    const HTMLAbrirFormularioFisicoQuimico = () => {
        return (
            <Modal
                open={openFormularioFisicoQuimico}
                onClose={handleCerrarModalFormularioFisicoQuimico}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={style} >
                    <FormularioFisicoQuimico actualizarAnalisis={actualizarAnalisis} clienteSeleccionado={clienteSeleccionado} loteSeleccionado={loteSeleccionado} analisis={analsisSeleccionado} cerrar={handleCerrarModalFormularioFisicoQuimico} cerrarVisualizacion={handleCerrarModalVerFisicoQuimico} cerrarModalAnalisis={handleCerrarModalFQ}></FormularioFisicoQuimico>
                </Box>

            </Modal>
        )
    }

    const HTMLAbrirVisualizarFisicoQuimico = () => {
        return (
            <Modal
                open={verAnalisis}
                onClose={handleCerrarModalVerFisicoQuimico}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleVisualizar} >
                    <VerAnalisisFQComponent onClose={handleCerrarModalVerFisicoQuimico} abrirActualizar={handleAbrirModalFormularioFisicoQuimico} analisis={analsisSeleccionado} clienteSeleccionado={clienteSeleccionado} documentos={documentosAnalisis}></VerAnalisisFQComponent>
                </Box>

            </Modal>
        )
    }

    const subirArchivo = () => {
        if (selectedFile != null) {

            const data = {
                idcliente: clienteSeleccionado.idcliente,
                lote: loteSeleccionado,
                file: selectedFile,
                analisis: analsisSeleccionado.analisisfq
            }
            dispatch(subirArchivosLotes(data)).then((res) => {
                const data = {
                    lote: analsisSeleccionado.analisisfq
                }
                dispatch(obtenerDocumentosByAnalisis(data)).then((res) => {
                    setDocumentosAnalisis(res.payload.data.data)
                    Store.addNotification({
                        title: "Documento guardado correctamente!",
                        message: "Guardado Correctamente",
                        type: "success",
                        insert: "top",
                        container: "top-center",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                            duration: 5000,
                            onScreen: true
                        }
                    });
                })
            })
            setSelectedFile(null)
        }
    }

    const [urlPDF, setUrlPDF] = React.useState('');

    const visualizarDocumento = async (ruta) => {
        let urlImg = hostSocket + "/";
        //PARA UBUNTU REMPLAZAR POR /
        let array = ruta.split("/")
        let empieza = 0;
        for (let i = 0; i < array.length; i++) {
            if (array[i] === 'docs') {
                empieza = i;
                break;
            }
        }
        for (let j = empieza; j < array.length; j++) {
            if (j === array.length - 1) {
                urlImg += array[j]
            } else {
                urlImg += array[j] + "/"
            }
        }
        setUrlPDF(urlImg)
        window.open(urlImg)
    }

    const borrarDocumento = () => {
        dispatch(eliminarDocumento(documentoSeleccionado.idlotesdocumentos)).then((res) => {
            const data = {
                lote: analsisSeleccionado.analisisfq
            }
            dispatch(obtenerDocumentosByAnalisis(data)).then((res) => {
                setDocumentosAnalisis(res.payload.data.data)
            })
        })
        handleCloseEliminarDocumento()
        Store.addNotification({
            title: "Documento eliminado correctamente!",
            message: "Eliminado Correctamente",
            type: "success",
            insert: "top",
            container: "top-center",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 5000,
                onScreen: true
            }
        });
    }

    const [openEliminarDocumento, setOpenEliminarDocumento] = React.useState(false);

    const [documentoSeleccionado, setDocumentoSeleccionado] = React.useState(null);

    const handleOpenEliminarDocumento = (d) => {
        setOpenEliminarDocumento(true)
        setDocumentoSeleccionado(d)
    };
    const handleCloseEliminarDocumento = () => setOpenEliminarDocumento(false);

    const modalEliminarDocumento = () => {
        return (
            <Modal
                open={openEliminarDocumento}
                onClose={handleCloseEliminarDocumento}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleBox}>
                    <div className='text-center'>
                        ¿Desea realmente eliminar este documento?<br /><br />
                        <button className='btn btn-danger' onClick={() => borrarDocumento()}> Eliminar</button>
                    </div>
                </Box>
            </Modal>
        )
    }

    const HTMLArchivosPDF = () => {
        return (
            <Modal
                open={openPDF}
                onClose={handleCerrarModalPDF}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={stylePDF} >
                    <div className='table-responsive'>
                        <h4>Analisis: <strong> {analsisSeleccionado?.analisisfq}</strong></h4>
                        <table className='table table-striped table-hover'>
                            <tbody>
                                {
                                    documentosAnalisis.map((d, index) => {
                                        let nombre = []
                                        //PARA UBUNTU REMPLAZAR POR /
                                        nombre = d.pathdocumento.split("/")
                                        return (
                                            < tr key={index}>
                                                <td className='text-center'><p>{nombre[nombre.length - 1]}</p></td>
                                                <td><button className='btn btn-primary' onClick={() => visualizarDocumento(d.pathdocumento)}><strong><Visibility></Visibility></strong></button></td>
                                                <td><button className='btn btn-danger' onClick={() => handleOpenEliminarDocumento(d)}><strong><DeleteOutlined></DeleteOutlined></strong></button></td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                    <hr />
                    <div className="mb-3">
                        <label htmlFor="formFileSm" className="form-label">Subir Archivo</label>
                        <input className="form-control form-control-sm" id="formFileSm" type="file" accept="application/pdf" onChange={handleChange} />
                        <br />
                        <button className='btn btn-sm btn-success' onClick={subirArchivo}>Guardar</button>
                    </div>
                </Box>

            </Modal >
        )
    }

    const HTMLAnalisisFQ = () => {
        return (
            <Modal
                open={openFQ}
                onClose={handleCerrarModalFQ}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={stylePDF} >
                    <div className='table-responsive'>
                        <h4>Lote: <strong>{loteSeleccionado}</strong></h4>
                        <table className='table table-striped table-hover'>
                            <thead>
                                <tr>
                                    <td className='text-center' style={{ fontSize: '16px' }}>Analísis Fisico Quimico</td>
                                    <td style={{ fontSize: '16px' }}>Ver Resumen</td>
                                    <td style={{ fontSize: '16px' }}>Ver Archivos</td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    analisis.map((a) => {
                                        return (
                                            <tr>
                                                <td className='text-center'>{a.analisisfq}</td>
                                                <td width={50}><button className='btn btn-sm btn-success' onClick={() => handleAbrirModalVerFisicoQuimico(a)}><RemoveRedEyeOutlined></RemoveRedEyeOutlined></button></td>
                                                <td width={50}><button className='btn btn-sm btn-warning' onClick={() => handleAbrirModalPDF(a)}><FindInPage></FindInPage></button></td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                    <hr />
                    <div className="mb-3">
                        <button className='btn btn-sm btn-success' onClick={handleAbrirModalFormularioFisicoQuimico}>Agregar Nuevo Analisis</button>
                    </div>
                </Box>

            </Modal>
        )
    }

    function obtenerRazonSocial(noCliente) {
        let cliente = clientes.filter(c => c.numerosocio == noCliente)
        if (cliente.length > 0) {
            return cliente[0].nombrerazonsocial
        }
    }


    return (
        <Fragment><br />
            <div className="container">
                <div className='row'>
                    <div>
                        <div className="d-flex" role="search">
                            <input className="form-control me-2" type="search" name='busqueda'
                                placeholder="Ingrese el número de cliente, razón social, o lote ..."
                                aria-label="Search" onChange={handleBuscarInstalaciones} value={cajaBusqueda} />
                        </div>

                        <div hidden={opcionesOcultas}>

                            {
                                clientesFiltrados.map((i, index) => (

                                    <p className={`${estilos.opciones}`} onClick={() => handleElegirCliente(i)} key={index}><strong>( {i.numerosocio} )</strong> {i.nombrerazonsocial}</p>
                                ))
                            }
                        </div>
                    </div>
                    <br />
                    <hr />
                    {
                        resultado == true ?
                            <p>Lotes del cliente: <strong>( {clienteSeleccionado.numerosocio} ) </strong>  {clienteSeleccionado.nombrerazonsocial}</p>
                            :
                            <Fragment></Fragment>
                    }
                    <div className='table-responsive'>
                        <table className='table table-striped table-hover'>
                            <thead>
                                <tr>
                                    <th>Cliente:</th>
                                    <th>Razón Social:</th>
                                    <th>ID Compuesto:</th>
                                    <th>Lote:</th>
                                    <th>Tipo Instalación:</th>
                                    <th>Acciones:</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    lotesFiltrados.map((l, index) => {
                                        return (
                                            <tr key={index}>
                                                {
                                                    resultado == true ?
                                                        <Fragment>
                                                            <td>{clienteSeleccionado.numerosocio}</td>
                                                            <td>{clienteSeleccionado.nombrerazonsocial}</td>
                                                            <td>{l.id_compuesto}</td>
                                                            <td>{l.lote}</td>
                                                            <td>{l.tipo_instalacion}</td>
                                                            <td>
                                                                <button className='btn btn-sm btn-success' onClick={() => handleAbrirModalFQ(l.lote)}>Análisis Físico Químico</button>
                                                            </td>
                                                        </Fragment>
                                                        :
                                                        <Fragment>
                                                            <td>{l.noCliente}</td>
                                                            <td>{obtenerRazonSocial(l.noCliente)}</td>
                                                            <td>{l.lote.id_compuesto}</td>
                                                            <td>{l.lote.lote}</td>
                                                            <td>{l.lote.tipo_instalacion}</td>
                                                            <td>
                                                                <button className='btn btn-sm btn-success' onClick={() => handleAbrirModalFQ(l.lote.lote)}>Análisis Físico Químico</button>
                                                            </td>
                                                        </Fragment>
                                                }


                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>

            {HTMLAbrirFormularioFisicoQuimico()}
            {HTMLArchivosPDF()}
            {modalEliminarDocumento()}
            {HTMLAnalisisFQ()}
            {HTMLAbrirVisualizarFisicoQuimico()}
        </Fragment>
    );
};


export default withRouter(TableBusquedaLotesComponent)
